import { render, staticRenderFns } from "./ServiceCol.vue?vue&type=template&id=0f787deb&"
import script from "./ServiceCol.vue?vue&type=script&lang=js&"
export * from "./ServiceCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports